import classNames from "classnames";
import React, { useState } from "react";
import arrowDownIcon from "../../assets/images/arrow-down.svg";
import checkmarkIcon from "../../assets/images/checkmark.svg";
import { SanityInputFieldType } from "../../models/form/SanityInputFieldType";
import { Collapse } from "../Collapse";

export interface SelectionSummaryItem {
  label: string;
  type: SanityInputFieldType;
  values: string[];
}

export interface SelectionSummaryProps {
  additionalClassName?: string;
  title: string;
  items: SelectionSummaryItem[];
}

export const SelectionSummary = ({
  additionalClassName = "",
  items,
  title
}: SelectionSummaryProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className={classNames(
        additionalClassName,
        "text-form-summary bg-brand-primary-100 border border-brand-primary-95",
        "text-lg",
        "transition-all duration-200",
        isOpen ? "rounded-2xl" : "rounded-md"
      )}
    >
      <button
        className="p-6 w-full flex items-center justify-between"
        onClick={() => setIsOpen(prev => !prev)}
      >
        {title}
        <svg
          width={13}
          height={9}
          className={classNames("stroke-current ml-2", { "rotate-180": isOpen })}
        >
          <use xlinkHref={arrowDownIcon.url} />
        </svg>
      </button>
      <Collapse isOpen={isOpen}>
        <ol className="p-6 pt-0 flex flex-col gap-4">
          {items.map((item, index) => (
            <li key={index}>
              <span className="text-form-summary-label">{item.label}</span>
              <ul className="pl-2 mt-2 flex flex-col gap-1">
                {item.values.map((value, valueIndex) => (
                  <li className="flex items-center" key={valueIndex}>
                    <div className="w-4 mr-3 text-brand-primary-70">
                      {item.type === "inputPriceCheckboxes" ? (
                        <svg width={14} height={14}>
                          <use xlinkHref={checkmarkIcon.url} />
                        </svg>
                      ) : (
                        <span
                          className={
                            "flex justify-center items-center w-4 h-4 rounded-full border border-current overflow-hidden"
                          }
                        >
                          <span className={"rounded-full w-2 h-2 bg-current"}></span>
                        </span>
                      )}
                    </div>
                    {value}
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ol>
      </Collapse>
    </div>
  );
};
